import React, { useEffect, useState, useRef } from 'react';
import { Breadcrumb, Button, Col, Form, Row, Select, Table, Tabs } from 'antd';
import { AppState } from 'src/store';
import { connect } from 'react-redux';
import { getCategoriesByOrganizationIdAndYear,  getGeiYearsByOrganizationId } from 'src/store/Results/thunks';
import { getAllOrganization } from 'src/store/organization/thunks';
import { getUserByToken } from 'src/store/user/thunks';
import { Organization } from '../../../store/organization/types';
import { Category } from 'src/store/category/type';
import { CategoryResponse, CategoryResults, ResultsResponse } from 'src/store/Results/types';
import style from './Results.module.scss'
import AdminHeader from 'src/globals/Layout/Admin/AdminHeader';
import { useHistory, useParams } from 'react-router-dom';
import ResultsHeader from './ResultsHeader';
interface ResultProps {

    getGeiYearsByOrganizationId?: any;
    getCategoriesByOrganizationIdAndYear?: any;
    getCategoriesByOrganizationIdAndYearAndCategory?: any;
    getAllOrganization?: any;
    getUserByToken?: any;
}



const ResultsMensual: React.FC<ResultProps> = (props: ResultProps) => {
    const [organization, setOrganization] = useState([]);
    const history = useHistory();
    const [typeOrganization, setTypeOrganization] = useState("");
    const [typeYears, setTypeYears] = useState("");
    const [category, setCategory] = useState([]);
    const [isNone, setIsNone] = useState("-none");
    const [results, setResults] = useState<ResultsResponse>();
    const { Option } = Select;
    interface RouteParams {
        type: string
    }
    const params = useParams<RouteParams>();
    const [year, setDataYears] = useState([]);
    const init = async () => {
        const rol = await props.getUserByToken();
        if (rol == "administrator" || rol == "super_admin") {
            const responseDataOrganization = await props.getAllOrganization();
            setOrganization(responseDataOrganization);
        } else if (rol == "client") {

        }
    }
    useEffect(() => {
        init();
    }, []);


    const handleChangeTypeOrganization = async (value: any) => {

        setTypeOrganization(value);
        setIsNone("-none")
        const responseData = await props.getGeiYearsByOrganizationId(value);
        if (responseData != undefined) {
            setDataYears(responseData);
        } else {
            setDataYears([])
            setIsNone("-none")
            setTypeYears("");
        }

    };
    const handleChangeTypeYears = async (value: any) => {
        setTypeYears(value);
        const responseData = await props.getCategoriesByOrganizationIdAndYear(typeOrganization, value);
        setIsNone("")
        setCategory(responseData.categoryResponse);
        setResults(responseData);
    };

    return (
        <div >
    <ResultsHeader annual={""} mensual={"-bold"} history={""}/>
    <Row justify="center" style={{ width: "100%" }}>
                <Col lg={2}></Col>
                <Col lg={8}>
                Escoga la organización:
                    <Select
                        showSearch
                        style={{ width: "100%" }}
                        onChange={handleChangeTypeOrganization}
                        filterOption={(input: any, option: any) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        value={typeOrganization}
                        placeholder="Escoga la organización"
                    >
                        {organization.map((type: Organization) => (
                            <Option key={`type-option-${type}`} value={type.id}
                            >
                                {type.ruc + "-" + type.name}
                            </Option>
                        ))}
                    </Select>
                </Col>
                <Col lg={4}>
                    Escoga el año
                    <Select

                        showSearch
                        style={{ width: "100%" }}
                        onChange={handleChangeTypeYears}
                        filterOption={(input: any, option: any) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        value={typeYears}
                        placeholder="Escoga el año"
                    >
                        {year.map((type: string) => (
                            <Option key={`type-option-${type}`} value={type}
                            >
                                {type}
                            </Option>
                        ))}
                    </Select>
                </Col>
                <Col lg={2}></Col>
            </Row>

            <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
                <div style={{ width: '217%' }}>
                    <div className={style["title-reults"]} >
                        1. DECLARACIÓN DE EMISIONES DE GEI
                    </div>
                    <Row justify="start" className={style["custom-row" + isNone]}>
                        <Col style={{ width: 200 }}>
                            Establecimiento
                        </Col>
                        <Col style={{ width: 200 }}>
                            Fuente de emisión
                        </Col>
                        <Col style={{ width: 200 }}>
                            Flujo de Fuente
                        </Col>
                        <Col style={{ width: 150 }}>
                            Ene
                        </Col>
                        <Col style={{ width: 150 }}>
                            Feb
                        </Col>
                        <Col style={{ width: 150 }}>
                            Mar
                        </Col>
                        <Col style={{ width: 150 }}>
                            Abr
                        </Col>
                        <Col style={{ width: 150 }}>
                            May
                        </Col>
                        <Col style={{ width: 150 }}>
                            Jun
                        </Col>
                        <Col style={{ width: 150 }}>
                            Jul
                        </Col>
                        <Col style={{ width: 150 }}>
                            Ago
                        </Col>
                        <Col style={{ width: 150 }}>
                            Sep
                        </Col>
                        <Col style={{ width: 150 }}>
                            Oct
                        </Col>
                        <Col style={{ width: 150 }}>
                            Nov
                        </Col>
                        <Col style={{ width: 150 }}>
                            Dic
                        </Col>
                        <Col style={{ width: 150 }}>
                            t CO₂e
                        </Col>
                        <Col style={{ width: 150 }}>
                            Aporte%
                        </Col>

                    </Row>
                    {category.map((type: CategoryResponse) => (
                        <div key={type.id} >
                            {type.categoryResults.map((type: CategoryResults) => (
                                <div key={type.establisment} >
                                    <Row justify="start" className={style["custom-row-data" + isNone]}>
                                        <Col style={{ width: 200 }}>
                                            {type.establisment}
                                        </Col>
                                        <Col style={{ width: 200 }}>
                                            {type.emissionSource}
                                        </Col>
                                        <Col style={{ width: 200 }}>
                                            {type.flow}
                                        </Col>
                                        <Col style={{ width: 150 }}>
                                            {type.ene}
                                        </Col>
                                        <Col style={{ width: 150 }}>
                                            {type.feb}
                                        </Col>
                                        <Col style={{ width: 150 }}>
                                            {type.mar}
                                        </Col>
                                        <Col style={{ width: 150 }}>
                                            {type.abr}
                                        </Col>
                                        <Col style={{ width: 150 }}>
                                            {type.may}
                                        </Col>
                                        <Col style={{ width: 150 }}>
                                            {type.jun}
                                        </Col>
                                        <Col style={{ width: 150 }}>
                                            {type.jul}
                                        </Col>
                                        <Col style={{ width: 150 }}>
                                            {type.ago}
                                        </Col>
                                        <Col style={{ width: 150 }}>
                                            {type.sep}
                                        </Col>
                                        <Col style={{ width: 150 }}>
                                            {type.oct}
                                        </Col>
                                        <Col style={{ width: 150 }}>
                                            {type.nov}
                                        </Col>
                                        <Col style={{ width: 150 }}>
                                            {type.dic}
                                        </Col>
                                        <Col style={{ width: 150 }}>
                                            {type.tcO2e}
                                        </Col>
                                        <Col style={{ width: 150 }}>
                                            {type.input + "%"}
                                        </Col>
                                    </Row>
                                </div>

                            ))}

                            <Row justify="start" className={style["custom-row-total" + isNone]}>
                                <Col style={{ width: 600 }}>
                                    {"Categoria " + type.type + " (" + type.name + ")"}
                                </Col>
                                <Col style={{ width: 150 }}>
                                  {type.totalEne}
                                </Col>
                                <Col style={{ width: 150 }}>
                                {type.totalFeb}
                                </Col>
                                <Col style={{ width: 150 }}>
                                {type.totalMar}
                                </Col>
                                <Col style={{ width: 150 }}>
                                {type.totalAbr}
                                </Col>
                                <Col style={{ width: 150 }}>
                                {type.totalMay}
                                </Col>
                                <Col style={{ width: 150 }}>
                                {type.totalJun}
                                </Col>
                                <Col style={{ width: 150 }}>
                                {type.totalJul}
                                </Col>
                                <Col style={{ width: 150 }}>
                                {type.totalAgo}
                                </Col>
                                <Col style={{ width: 150 }}>
                                {type.totalSep}
                                </Col>
                                <Col style={{ width: 150 }}>
                                {type.totalOct}
                                </Col>
                                <Col style={{ width: 150 }}>
                                {type.totalNov}
                                </Col>
                                <Col style={{ width: 150 }}>
                                {type.totalDic}
                                </Col>
                                <Col style={{ width: 150 }}>
                                    {type.totaltco2e}
                                </Col>
                                <Col style={{ width: 150 }}>
                                    {type.totalinput + "%"}
                                </Col>
                            </Row>


                        </div>
                    ))}
                    <Row justify="start" className={style["custom-row-total" + isNone]}>
                        <Col style={{ width: 600 }}>
                            Total Emisiones CO₂e (t)
                        </Col>
                        <Col style={{ width: 150 }}>
                        {results?.totalEmissionEne}  
                                </Col>
                                <Col style={{ width: 150 }}>
                                {results?.totalEmissionFeb}  
                                </Col>
                                <Col style={{ width: 150 }}>
                                {results?.totalEmissionMar}  
                                </Col>
                                <Col style={{ width: 150 }}>
                                {results?.totalEmissionAbr}  
                                </Col>
                                <Col style={{ width: 150 }}>
                                {results?.totalEmissionMay}  
                                </Col>
                                <Col style={{ width: 150 }}>
                                {results?.totalEmissionJun}  
                                </Col>
                                <Col style={{ width: 150 }}>
                                {results?.totalEmissionJul}  
                                </Col>
                                <Col style={{ width: 150 }}>
                                {results?.totalEmissionAgo}  
                                </Col>
                                <Col style={{ width: 150 }}>
                                {results?.totalEmissionSep}  
                                </Col>
                                <Col style={{ width: 150 }}>
                                {results?.totalEmissionOct}  
                                </Col>
                                <Col style={{ width: 150 }}>
                                {results?.totalEmissionNov}  
                                </Col>
                                <Col style={{ width: 150 }}>
                                {results?.totalEmissionDic}  
                                </Col>
                        <Col style={{ width: 150 }}>
                            {results?.totalEmissiontco2e}
                        </Col>
                        <Col style={{ width: 150 }}>
                            {results?.totalEmissioninput + "%"}
                        </Col>
                    </Row>
                    <Row justify="start" className={style["custom-row-data-total" + isNone]}>
                        <Col style={{ width: 400 }}>
                            Emisiones biogénicas por combustión de biomasa CO₂ (t)
                        </Col>
                        <Col style={{ width: 50 }}>
                            {results?.totalEmissionBiomasa}
                        </Col>


                    </Row>
                    <Row justify="start" className={style["custom-row-data-total" + isNone]}>
                        <Col style={{ width: 400 }}>
                            Emisiones HCFC
                        </Col>
                        <Col style={{ width: 50 }}>
                            {results?.totalHcfc}
                        </Col>
                    </Row>

                </div>

            </div>

        </div>

    );
};
const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
    getGeiYearsByOrganizationId, getCategoriesByOrganizationIdAndYear,
    getAllOrganization, getUserByToken
})(ResultsMensual);